module.exports = __webpack_public_path__ + "static/organicleopardmultipk-4f4072d0f7d3a75f3522ac2fb6f27b14.jpeg";